<template>
    <div class="mt-5">
        <delete-confirmation name="note" @confirm="deleteNote"></delete-confirmation>
        <div class="d-flex justify-content-between align-items-end border-bottom">
            <div class="h4">Notes</div>
            <button type="button" class="btn btn-primary mb-1" data-toggle="modal" data-target="#attorneyNoteModal" title="Add Note">
                <i class="fas fa-comment"></i>
            </button>
        </div>

        <div class="modal fade" id="attorneyNoteModal" tabindex="-1" role="dialog" aria-labelledby="attorneyNoteTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="modal-title" id="noteTitle">{{ noteId ? 'Edit' : 'Add' }} Note</div>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>                        
                    </div>
                    <div class="modal-body text-center">
                        <textarea id="note" name="note" class="form-control mt-1" rows="8" v-model="noteText" autofocus></textarea>
                    </div>
                    <div class="modal-footer">
                        <button type="submit" class="btn btn-primary" :disabled="!noteText" @click="save()">Save</button>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>                        
                    </div>                                          
                </div>
            </div>
        </div>

        <div v-for="note in notes" :key="'attorney-claim-note-' + note.id">
            <div class="d-flex flex-row mt-3">
                <div>
                    <i v-if="note.is_linked" class="fas fa-link fa-sm text-muted linked-icon"></i>
                </div>
                <div class="px-3 flex-grow-1" v-text="note.text"></div>
                <div class="d-flex mb-auto">                  
                    <button v-if="note.can_edit" class="btn btn-link btn-lg p-0 mx-1" @click="edit(note)" title="Edit Note">
                        <i class="fas fa-edit edit-button"></i>
                    </button>
                    <button  v-if="note.can_edit" class="btn btn-link btn-lg p-0 mx-1" @click="togglePrivacy(note)" title="Toggle Privacy">
                        <i :class="['fas edit-button', note.private ? 'fa-lock' : 'fa-lock-open']"></i>
                    </button>                    
                    <button v-if="note.can_edit" class="btn btn-link btn-lg p-0 mx-1" @click="confirmDelete(note)" title="Delete Note" :disabled="note.is_linked">
                        <i class="fas fa-trash-alt edit-button"></i>
                    </button>
                    <button v-if="disputeCount && note.can_associate" class="btn btn-link p-0 mx-1" title="Link Note" @click="associateNote(note)">
                        <i class="fas fa-link link-button"></i>
                    </button>                      
                </div>
            </div>
            <div class="d-flex flex-row justify-content-end border-bottom mt-1">
                <div class="text-muted pb-2 pr-3">
                    <small>{{ note.user.first_name + ' ' + note.user.last_name + ' - ' }}{{ note.created_at | localizeTime('lll') }}</small>
                    <i v-if="note.created_at != note.updated_at" class="fas fa-pencil-alt fa-sm text-muted" :title="getEditedString(note.updated_at)"></i>
                </div>
            </div>
        </div>
    </div>    
</template>

<script>
export default {
    props: {
        claimId: Number
    },
    data() {
        return {
            notes: [],
            noteId: null,
            noteText: null,
            private: false,
            disputeCount: 0
        };
    },    
    methods: {
        refresh: function() {

            var self = this;

            this.noteId = null;
            this.noteText = null;

            axios.get('/ajax/attorney/claims/' + self.claimId + '/notes/')
                .then(function(response) {
                    self.notes = response.data.notes;
                    self.disputeCount = response.data.dispute_count;            
                })
                .catch(error => {
                    console.log(error);
                });            
        },
        save: function() {

            if (this.noteText.trim()) {

                let method = this.noteId ? 'patch' : 'post';
                let url = this.noteId ? `/ajax/attorney/claims/${this.claimId}/notes/${this.noteId}` : `/ajax/attorney/claims/${this.claimId}/notes`;
                let data = { text: this.noteText, private: this.private };

                axios({ method, url, data }) 
                    .then(response => {
                        this.noteId = null;
                        this.noteText = null;
                        $('#attorneyNoteModal').modal('hide');   
                    })
                    .catch(error => {
                        console.log(error);
                        $('#attorneyNoteModal').modal('hide');
                    });                    
            }         
        },
        edit: function (note) {

            if (note.can_edit) {

                this.noteId = note.id;
                this.noteText = note.text;
                $('#attorneyNoteModal').modal('show');
            }
        },
        getEditedString: function (value) {

            const editDateTime = this.$options.filters.localizeTime(value, 'lll');
            return 'Edited ' + editDateTime;
        },
        togglePrivacy: function (note) {

            let privacy = !note.private;
            axios.patch(`/ajax/attorney/claims/${this.claimId}/notes/${note.id}/privacy`, {
                private: privacy
            })
            .catch(error => {
                if (error.response.data.message) {
                    let message = error.response.data.message;
                    toastr['error'](message, 'ERROR', {timeOut: 10000, positionClass: "toast-top-full-width", closeButton: true});
                }            
            });
        },         
        confirmDelete: function (note) {

            eventHub.$emit('show-delete-note-confirmation', note, 'note');
        },        
        deleteNote: function (note) {

            axios.delete('/ajax/attorney/claims/' + this.claimId + '/notes/' + note.id)
                .catch(error => {
                    let message = error.response.data.message;
                    toastr['error'](message, 'Error', {timeOut: 10000, positionClass: "toast-top-full-width", closeButton: true});                    
                });            
        },        
        associateNote: function (note) {

            if (this.disputeCount === 1) {

                // there is only one 1008 in the claim so associate with it
                axios.post('/ajax/attorney/claims/' + this.claimId + '/notes/' + note.id + '/associate')
                    .catch(error => {
                        toastr['error'](error.response.data.message, 'Error', { timeOut: 10000, positionClass: "toast-top-full-width", closeButton: true });
                    });
            }
            else if (this.disputeCount > 1) {

                // allow the user to select which 1008s to associate with
                eventHub.$emit('show-attorney-dispute-note-association', this.claimId, note);
            }
        }
    },
    created() { 
        this.refresh();

        window.Echo.private('claims.' + this.claimId)
            .listen('NoteEvent', (e) => {
                this.refresh();
            });          
        
    },    
    mounted() {

        var self = this;

        $('#attorneyNoteModal').on('shown.bs.modal', function (e) {
            $('#note').focus();
        });

        $('#attorneyNoteModal').on('hidden.bs.modal', function (e) {
            self.noteId = null;
            self.noteText = null;
        });       
    }
}
</script>

<style scoped>
    .linked-icon {
        position: relative;
        top: -3px;
    }

    .icon-hidden {
       color: transparent; 
    }

    .edit-button {
        font-size: 1em;
    }

    .link-button {
        font-size: 1.2em;
        position: relative;
        top: 2px;
    }
</style>